import { render, staticRenderFns } from "./vCarousel.vue?vue&type=template&id=bfdf674e&scoped=true"
import script from "./vCarousel.vue?vue&type=script&lang=js"
export * from "./vCarousel.vue?vue&type=script&lang=js"
import style0 from "./vCarousel.vue?vue&type=style&index=0&id=bfdf674e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfdf674e",
  null
  
)

export default component.exports